export const DISPLAY_APPEARANCE = {
    ABOVE_GROUND: 'above_ground',
    GROUND: 'ground',
    BELOW_GROUND: 'below_ground',
};

export const EXTERNAL_LEVEL = {
    id: null,
    code: 'EXT',
    name: 'External',
    displayAppearance: DISPLAY_APPEARANCE.GROUND,
    isDefault: false,
    orderId: 0,
    relatedLevelIds: [null],
};

export const filterFeaturesByLevelId = (features, levelId, clientId) => {
    return features.filter(
        feature =>
            (feature.properties.levelId === levelId && feature.properties.clientId === clientId) ||
            (!feature.properties.levelId && !levelId)
    );
};

export const getLevelUniqueId = (levelId, clientId) => (levelId ? `${clientId}-${levelId}` : null);

export const parseLevelUniqueId = levelUniqueId => {
    if (!levelUniqueId) {
        return null;
    }
    const lastIndex = levelUniqueId.lastIndexOf('-');
    const clientId = levelUniqueId.substring(0, lastIndex);
    const levelId = parseInt(levelUniqueId.substring(lastIndex + 1), 10);
    return {clientId, levelId};
};

export const getLevelByUniqueId = (levelUniqueId, levels) =>
    levels.find(
        level => (!level.id && !levelUniqueId) || level.relatedLevelIds.includes(levelUniqueId)
    );
